import React, { useEffect, useState } from 'react';
import Place from '../Place/Place';
import './Places.css'
 

const Places = () => {
    const [places, setPlaces] = useState([]);
    useEffect(()=> {
        fetch('https://ghastly-flesh-56862.herokuapp.com/services')
        .then(res => res.json())
        .then(data => setPlaces(data));
    }, [])
    return (
        <div> <h1 className="gallery-title py-4 my-4" >OUR RESORTS</h1>
        <div className="place-container">
           
           {
               places.map(place =><Place
               key = {place.name}
               place = {place}
               ></Place>)
           }
            
        </div>
        </div>
    );
};

export default Places;